import React from 'react';
import s from './Menu.module.css';
import Item from './Item';
import sushi_img from '../../img/Sushi.png'
import mak_img from '../../img/Mak.png'
import pizza_img from '../../img/Pizza.png'
import salad_img from '../../img/Salad.jpg'
import firstCourses_img from '../../img/First_courses.png'
import secondCourses_img from '../../img/Second_courses.png'
import sandwich_img from '../../img/sandwich.png'
import pasta_img from '../../img/pasta.png'
import iceDriks_img from '../../img/ice_drinks.png'
import hotDriks_img from '../../img/chocolade.jpg'
import coffee_img from '../../img/coffee.png'
import cupcake_img from '../../img/cupcake.png'
import kids_img from '../../img/kids menu.webp'
import smuzi_img from '../../img/smuzi.png'
import vafle_img from '../../img/vafle.png'

const Menu = (props) => {
    return (
        <div className={s.menu}>
            <nav className={s.nav}>
                <span className={s.title}>Меню</span>
            </nav>
            <main className={s.main}>
                <Item link='/sushi' name='Суші' img={sushi_img}/>
                <Item link='/makmenu' name='Мак Меню' img={mak_img}/>
                <Item link='/pizzas' name='Піци' img={pizza_img}/>
                <Item link='/kidsMenu' name='Дитяче меню' img={kids_img}/>
                <Item link='/first_courses' name='Перші страви' img={firstCourses_img}/>
                <Item link='/garnir' name='Другі страви' img={secondCourses_img}/>
                <Item link='/pasta' name='Пасти' img={pasta_img}/>
                <Item link='/salads' name='Салати' img={salad_img}/>
                <Item link='/sandwich' name='Сендвiчi' img={sandwich_img}/>
                <Item link='/sweet' name='Десерти' img={cupcake_img}/>
                <Item link='/coffee' name='Кава та чай' img={coffee_img}/>
                <Item link='/hot_drinks' name='Гарячі напої' img={hotDriks_img}/>
                <Item link='/ice_drinks' name='Ходні напої' img={iceDriks_img}/>
                <Item link='/smuzi' name='Смузі, Мілкшейки' img={smuzi_img}/>
                <Item link='/bubble' name='Bubble вафля' img={vafle_img}/>
            </main>
        </div>
    )
}

export default Menu;